import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import LocalizedLink from 'helpers/LocalizeLink';
import { useSelector } from 'react-redux';
import Picture from 'components/elements/Picture';

function TextImageTextWidget(props) {
    const auth = useSelector(store => store.auth);

    const Iteration = ({ className, pos }) => {
        const [element, setElement] = useState(null);

        useEffect(() => {
            if (props?.items) {
                setElement(props.items.filter((obj, key) => {
                    return obj.text ? (pos ? (key > 2) : (key < 3)) : false
                }))
            }
        }, [pos])

        if (!element || element.length === 0) return null

        return (
            <div className={className}>
                {
                    element.map((item, index) => {
                        return (
                            item.text ?
                                <h3 data-test-id={"tit-" + item?.text} key={(pos ? 'titrs_' : 'titls_') + index} className={(props?.dark ? "text-white " : "") + "text-sm-big text-bold text-italic mx-auto mb-3 mb-md-0"}>
                                    <span className="custom-design">
                                        <span className="custom-design-circle"></span>
                                        <span className="custom-design-line"></span>
                                    </span>
                                    {item.text}
                                </h3> : null
                        )
                    })
                }
            </div>
        )
    }

    if (!props?.title && !props?.descriptions && !props?.additional_text && !props?.button_text && !props?.path && !props?.first_block_title && !props?.second_block_title && !props?.items) return null;

    return (
        <div data-test-id="tit-wr" className={"widget widget-textimagetext" + (props?.dark ? " bg-dark" : "")}>
            <div className="container-xl row text-center mx-auto p-0">
                <div className="col-12">
                    {props?.title ? <h2 data-test-id="tit-title" className="text-color-changeable mb-20">{props.title}</h2> : null}
                    {props?.descriptions ? <div data-test-id="tit-description" className={(props?.dark ? 'text-white ' : '') + "text-sm-medium text-semibold mb-20"}>{props.descriptions}</div> : null}
                    {props?.additional_text ? <div data-test-id="tit-add-text" className="text-color-changeable text-semibold text-sm-medium text-italic mb-20">{props.additional_text}</div> : null}
                    {
                        props?.button_text && props?.path ?
                            <>
                                {
                                    auth && (props.path === '/auth' || props.path === 'auth') ?
                                        <LocalizedLink dti="tit-btn" className={"btn h-42 px-12" + (props?.dark ? ' btn-dark' : '')}
                                            to={'/price'}>
                                            {props.button_text}
                                        </LocalizedLink>
                                        :
                                        <LocalizedLink dti="tit-btn" className={"btn h-42 px-12" + (props?.dark ? ' btn-dark' : '')}
                                            to={props.path ? props.path : null}>
                                            {props.button_text}
                                        </LocalizedLink>
                                }
                            </> : null
                    }
                </div>
                {
                    props?.first_block_title || props?.second_block_title ?
                            <>
                                {props.first_block_title ? <p data-test-id="tit-first-block" className={(props?.dark ? "text-white " : "") + "col-12 col-md-6 text-big text-semibold text-italic mt-20 mt-sm-12 mb-20 mb-sm-12"}>{props.first_block_title}</p> : null}
                                {props.second_block_title ? <p data-test-id="tit-second-block" className={(props?.dark ? "text-white " : "") + "col-12 col-md-6 text-big text-semibold text-italic mt-20 mt-sm-12 mb-20 mb-sm-12"}>{props.second_block_title}</p> : null} 
                            </>
                        : null
                }
                {
                    props?.img?.source || props?.img_mob?.source ?
                        <div className="col-12 custom">
                            {
                                props?.items && props?.items.length>0 ?
                                    <>
                                        <Iteration className="custom-left" pos={0} />
                                        <Iteration className="custom-right" pos={1} />
                                    </>
                                    :null
                            }
                            <Picture dti="tit-img" img={props.img} img_mob={props.img_mob} className='w-100 mb-20' />
                        </div>
                        : null
                }
            </div>
        </div>
    )
}

TextImageTextWidget.propTypes = {
    title: PropTypes.string,
    descriptions: PropTypes.string,
    additional_text: PropTypes.string,
    button_text: PropTypes.string,
    path: PropTypes.string,
    img: PropTypes.object,
    position: PropTypes.number,
    widget: PropTypes.string,
    className: PropTypes.string,
    text: PropTypes.array,
}

export default TextImageTextWidget;
